import { ApiService } from './api.service';
import { Teacher } from '@/models/teacher/teacher';
import { ImportTeacherResult } from '@/models/teacher/import-teacher-result';
import { PagingData } from '@/models/core/paging-data';
import { TeacherPasswordRequest } from '@/models/teacher/teacher-password-request';
import { TeacherRequest } from '@/models/teacher/teacher-request';

class TeacherService extends ApiService {
  constructor() {
    super();
  }

  getTeachers(sortKey: number = 1, sortType: number = 1): Promise<Teacher[]> {
    return this.getList(Teacher, 'teachers', {
      sortKey,
      sortType,
    });
  }

  getTeacherDetail(teacherID: number): Promise<Teacher> {
    return this.get(Teacher, `teachers/${teacherID}`, {});
  }

  updateTeacherDetail(teacherDetailEdit: TeacherRequest): Promise<Teacher> {
    return this.put(Teacher, `teachers/${teacherDetailEdit.teacherID}`, teacherDetailEdit);
  }

  updateTeacherPassword(teacherID: number, params: TeacherPasswordRequest): Promise<Teacher> {
    return this.put(Teacher, `teachers/${teacherID}/password`, params);
  }

  downloadTeacherRegistrationTemplate(isUpdate: boolean, hasInvalid: boolean = false): Promise<Blob> {
    return this.downloadFile('teachers/template', { isUpdate, hasInvalid });
  }

  postTeachersExcel(params: FormData): Promise<ImportTeacherResult> {
    return this.postFile(ImportTeacherResult, 'teachers/import', params);
  }

  addTeacherDetail(params: TeacherRequest): Promise<Teacher> {
    return this.post(Teacher, 'teachers', params);
  }
}

export const teacherService = new TeacherService();
